import {Col, Container, Modal, Row} from "react-bootstrap";
import {AppContext} from "../../lib/AppContext";
import React, {useContext, useState} from "react";
import {handleDefaultValues} from "../common/Utils";
import {useForm} from 'react-hook-form';
import MDButton from "../../components/MDButton";
import MDInput from "../../components/MDInput";

export default function ManageTipTypeModal({tipType, handleSave, handleClose, saving, show}) {

  const [context, setContext] = useContext(AppContext);
  const [formInvalid, setFormInvalid] = useState(false);

  const [isNew, setIsNew] = useState(!!!tipType?.guid);

  const {register, handleSubmit, setValue, control} = useForm({
    values: handleDefaultValues(tipType)
  });

  const handleSaveFn = (data) => {
    handleSave(data);
  };

  return (
    <Modal onHide={handleClose} size={'sm'} show={show}>
      <form onSubmit={handleSubmit(handleSaveFn)} id={'tipTypeForm'}>
        <Modal.Header closeButton>
          <Modal.Title>{isNew ? 'Create New' : 'Manage'} Tip Percentage</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col className={'col col-main'} xs={12}>
              <Container>
                <Row>
                  <Col className={'col'} sm={12} xs={12}>
                    <div className="form-group">
                      <MDInput
                        min={0}
                        max={100}
                        InputLabelProps={{shrink: true}}
                        placeholder={"Enter Tip Percentage"}
                        type="number"
                        {...register('tipPercentage', {
                          valueAsNumber: true
                        })}
                        autoComplete="off" required
                        className="form-control" id="name"
                        label="Tip Percentage"/>
                    </div>
                  </Col>
                </Row>
              </Container>
            </Col>
          </Row>

        </Modal.Body>
        <Modal.Footer>
          <MDButton type="submit" color="info" disabled={formInvalid || saving}>
            {saving ? 'Saving...' : 'Save'}
          </MDButton>
        </Modal.Footer>
      </form>
    </Modal>
  );
}